import script from './SdsTabsSecondaryItem.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sds-tabs-secondary-item sds-focus",class:{ active: _vm.isActive, disabled: _vm.isDisabled },on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-69dd34ca_0", { source: ".sds-tabs-secondary-item[data-v-69dd34ca]{font-weight:400;font-size:12px;display:flex;height:32px;padding:0 8px;justify-content:center;align-items:center;background:var(--component-filter-tab-secondary-inactive-bg);border-radius:var(--radius-sm);border:1px solid transparent;color:var(--component-filter-tab-secondary-inactive-text);cursor:pointer;white-space:nowrap;transition:color .2s ease-in-out,background-color .2s ease-in-out,border-color .2s ease-in-out}.sds-tabs-secondary-item[data-v-69dd34ca]:last-of-type{margin-right:0}.sds-tabs-secondary-item[data-v-69dd34ca]:hover{background:var(--component-filter-tab-secondary-inactive-bg-hover)}.sds-tabs-secondary-item[data-v-69dd34ca]:active{background:var(--component-filter-tab-secondary-inactive-bg-pressed)}.sds-tabs-secondary-item.active[data-v-69dd34ca]{font-weight:600;font-size:12px;background:var(--component-filter-tab-secondary-active-bg);color:var(--component-filter-tab-secondary-active-text)}.sds-tabs-secondary-item.active[data-v-69dd34ca]:hover{background:var(--component-filter-tab-secondary-active-bg-hover)}.sds-tabs-secondary-item.active[data-v-69dd34ca]:active{background:var(--component-filter-tab-secondary-active-bg-pressed)}.sds-tabs-secondary-item.disabled[data-v-69dd34ca]{color:var(--system-text-on-elevation-disabled);cursor:not-allowed}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-69dd34ca";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
